import {OutlinedInput} from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import SearchBar from 'components/Forms/SearchBar'
import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

const SEARCH_SELECT_ITEMS: SelectItem<KeyOfAnalysisSearchKind>[] = [
  {label: 'IAMciIndex', value: 'INDEX'},
  {label: 'IPatientName', value: 'NAME'},
  {label: 'IFileName', value: 'FILE_NAME'},
  {label: 'IIndividualIndex', value: 'INDIVIDUAL_INDEX'},
]

interface SelectAnalysisSearchProps {
  onSearch: (params: AnalysisSearchKind) => void
}

export default function MciAnalysisSearch({
  onSearch,
}: SelectAnalysisSearchProps) {
  const classes = useToolbarStyles()
  const outlinedInputClasses = useOutlinedInputStyles()

  const {t} = useTranslation()

  const [searchCondition, setSearchCondition] =
    useState<KeyOfAnalysisSearchKind>('NAME')
  const [searchKeyword, setSearchKeyword] = useState('')

  const handleSearchChanged = (event: React.ChangeEvent<{value: unknown}>) =>
    setSearchCondition(event.target.value as KeyOfAnalysisSearchKind)

  const getSearch = (): AnalysisSearchKind => {
    if (searchCondition === 'INDEX') {
      return {
        searchName: searchCondition,
        searchValue: Number.parseInt(searchKeyword, 10),
      }
    }
    if (searchCondition === 'ECEO') {
      return {
        searchName: searchCondition,
        searchValue: searchKeyword as ECEOSearch['searchValue'],
      }
    }
    return {
      searchName: searchCondition,
      searchValue: searchKeyword,
    }
  }

  const handleSearch = () => {
    console.log(getSearch())
    const newSearch = getSearch()
    onSearch(newSearch)
  }

  const handleValue = (value: any) => {
    setSearchKeyword(value)
  }

  return (
    <div className={classes.searchContainer}>
      <FormControl variant='outlined'>
        <Select
          value={searchCondition}
          onChange={handleSearchChanged}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {SEARCH_SELECT_ITEMS.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SearchBar
        onChangeValue={handleValue}
        onSearchEvent={handleSearch}
        disabledValue={false}
      />
    </div>
  )
}
